export default "__VITE_PUBLIC_ASSET__ee83fa74__"